import React, {Component} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import Welcome from './components/Welcome';
import GlobalLogin from './components/GlobalLogin'
import Home from './pages/Home'
import WritersBenefit from './pages/WritersBenefit'
import Income from './pages/Income'
import Notifications from './pages/Notifications'
// import Audiobooks from './pages/Shows/Audiobooks'
import Novels from './pages/Shows/Novels'
import Profile from './components/Profile'
import NovelActionPage from './pages/Shows/Novels/action'
import ComingSoon from './pages/ComingSoon'
import Logout from './components/Logout'
import {isLoggedIn} from './lib/utils'
import WritingTips from './pages/Shows/Novels/writingTips'
import NotFound404 from './pages/NotFound404';
import Resetpassword from './components/GlobalLogin/resetPassword';
import Contest from './pages/Contest';
import Revenue from "./pages/Revenue";
import Analytics from './pages/Analytics';
import Faq from './pages/Faq';
import EmailRedirect from './pages/EmailRedirect'
import WritersAcademy from './pages/WritersAcademy';
import ContentAndCommunityGuidelines from './pages/ContentGuidelines';
import Onboarding from './components/Onboarding';
import User from './components/User';

const isRolePermitted = () => true
export default class Routes extends Component {
    render() {
        const PrivateRoute = ({component: Component, ...rest}) => {
            const redirectToLogin = !isLoggedIn() || !isRolePermitted
            return <Route
                {...rest}
                render={props => (
                    !redirectToLogin ? (
                        <>
                            <Component
                                {...props}
                            />
                        </>
                    ) : (
                        <Redirect to={{
                            pathname: '/logout',
                            state: {from: props.location}
                        }}/>
                    )
                )
                }
            />
        }
        

        return (
            <Switch>
                <Route exact path='/' component={User}/>
                <Route exact path='/onboarding' component={Onboarding}/>
                <Route path='/logout' component={Logout}/>
                <Route path='/login' component={Welcome}/>
                <Route path='/email-redirect' component={EmailRedirect}/>
                <Route path='/contest/:titleId' component={Contest} exact/>
                <Route path='/globalLogin' component={GlobalLogin}/>
                <Route path='/author-welfare' component={WritersBenefit} exact/>
                <Route path='/writers-academy/' component={WritersAcademy} exact/>
                <Route path='/writers-academy/:id' component={WritersAcademy}/>
                <Route path='/author-welfare/:language' component={WritersBenefit}/>
                <Route path='/content-and-community-guidelines' component={ContentAndCommunityGuidelines}/>
                {/* <Route path='/author-welfare-global' component={WritersBenefit} exact/> */}
                <Route path='/author-welfare-usa' component={WritersBenefit} exact/>
                <Route path='/reset-password' component={Resetpassword}/>
                <PrivateRoute path='/shows/novels' component={Novels} exact/>
                <PrivateRoute path='/shows/novels/writing-tips' component={WritingTips} exact/>
                <PrivateRoute path='/shows/novels/:action?/:id?' component={NovelActionPage} exact/>
                <PrivateRoute path='/shows/podcasts' component={ComingSoon} exact/>
                <PrivateRoute path='/analytics/engagement' component={ComingSoon} exact/>
                <PrivateRoute path='/analytics/audience' component={ComingSoon} exact/>
                <PrivateRoute path='/edit-profile' component={Profile} exact/>
                <PrivateRoute path='/home' component={Home} exact/>
                <PrivateRoute path='/faqs' component={Faq} exact/>
                <PrivateRoute path='/writers-benefit' component={WritersBenefit} exact/>
                <PrivateRoute path='/income' component={Income} exact/>
                <PrivateRoute path='/revenue' component={Revenue} exact/>
                <PrivateRoute path='/analytics' component={Analytics} exact/>
                <PrivateRoute path='/notifications' component={Notifications} exact/>
                <Route path="*" component={NotFound404}/>
            </Switch>
        )
    }
}
